var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccountability(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 68.474,
    height: 78.453,
    viewBox: "0 0 68.474 78.453",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_105",
    "data-name": "Rectangle 105",
    width: 115.705,
    height: 89.176,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1468",
    "data-name": "Path 1468",
    d: "M34.689,77.554C48.582,73.482,59.878,63.9,65.166,50.3c3.35-8.613,2.318-18.565,2.3-27.628-.012-5.793.04-11.586.007-17.378,0,0-11.735-3.548-32.783-3.548C14.1,1.75,1.907,5.3,1.907,5.3c-.033,5.792.019,11.585.007,17.378C1.9,31.74.863,41.692,4.214,50.3,9.5,63.9,20.8,73.482,34.689,77.554Z",
    transform: "translate(-0.453 -0.453)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1469",
    "data-name": "Path 1469",
    d: "M61.566,4.184s-18.6,41.364-50.525,54.1",
    transform: "translate(-2.858 -1.083)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1470",
    "data-name": "Path 1470",
    d: "M73.621,27.277S63.9,54.688,25.533,76.646",
    transform: "translate(-6.608 -7.06)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1471",
    "data-name": "Path 1471",
    d: "M17.481,28.931l6.14,6.14L37.813,20.879",
    transform: "translate(-4.525 -5.404)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountability);
export default __webpack_public_path__ + "static/media/accountability.886373fa058ba00ceeedaa031c3b44a6.svg";
export { ForwardRef as ReactComponent };